import {Spin} from "antd";

function SpinElement() {
	return (
		<div className={'container-wide_centered'}><Spin size="large"/></div>
	);
}

export default SpinElement;